import { useTranslation } from 'react-i18next';

import { Badge } from '../Badge/Badge';

import type { VFC } from 'react';

export const SimpleLiveBadge: VFC = () => {
  const { t } = useTranslation();

  return <Badge kind="live" label={t('Live')} />;
};
